module.exports = __webpack_public_path__ + "static/media/cherryBlossomsLeft.a05ea763.png";